import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Row, Col, Card, CardHeader, CardBody, CardFooter, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { Input } from "../common";
import routesService from "../service/routeService";
import { login } from "../service/auth";

const Login = (props) => {
	const [loading, setloading] = useState(false);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	let navigate = useNavigate();

	const handleLogin = async () => {
		setloading(true);
		try {
			if (!email) return toast.error("Please Enter Email");
			if (!password) return toast.error("Please Enter Password");
			let user = await login(email, password);
			if (!user) {
				toast.info(`User not found`);
				return;
			}
			navigate(routesService.getHomePageRoute());
		} catch ({ message }) {
			toast.error(message);
		} finally {
			setloading(false);
		}
	};

	return (
		<Row className="justify-content-center" style={{ marginTop: "200px" }}>
			<Col xs={12} md={6} lg={3}>
				<Card style={{ border: "0px" }}>
					<div className="text-start">
						<div
							style={{
								fontSize: "2rem",
								fontWeight: "700",
								textAlign: "center",
								marginBottom: "10px",
							}}
						>
							Analytics
						</div>
						<div>Welcome back,</div>
						<div>Please sign in to your account</div>
					</div>
					<CardBody
						className="px-0"
						onKeyPress={(e) => {
							if (["Enter", 13].includes(e.key)) login();
						}}
					>
						<Input placeholder="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
						<Input
							placeholder="Password"
							type="password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className="mt-3"
						/>
					</CardBody>
					<div className="text-start px-0" style={{ width: "11rem" }}>
						<Button disabled={loading} color="primary" onClick={handleLogin}>
							Login to dashboard {loading && <Spinner size="sm" />}
						</Button>
					</div>
				</Card>
			</Col>
		</Row>
	);
};

export default Login;
